export default {
    spMax: '767px',
};
//# sourceMappingURL=breakpoint.js.map